import { Box, styled, Button as Btn, css, Button } from '@mui/material';

export const Header = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #bdbdbd;
  padding: 0px 0px 16px;
  position: relative;

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
  }
`;

export const Typography = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
  .assinados {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #4caf50;
  }
  .pendentes {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #d62237;
  }

  .text {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
  }

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;

    display: flex;
    align-items: center;
    text-align: center;
    color: #4caf50;
  }

  .desc {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.15px;
    color: #212121;
  }
`;

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: overlay;
  background: #f5f5f5;
  padding: 42px 30px;
`;

export const SectionSignatures = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 20px;
  gap: 30px;
  margin-bottom: 20px;
  width: 100%;
  height: 215px;

  background: #ffffff;
  border-radius: 6px;
`;

export const Dashboard = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px;
  gap: 10px;

  width: 100%;
  height: 175px;

  /* Grey / 100 */

  background: #f5f5f5;
  border-radius: 6px;

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    letter-spacing: 0.15px;
    color: #000000;
  }

  .docsPendents {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 20px;

    width: 100%;
    min-height: 91px;

    background: rgba(208, 19, 23, 0.1);
    border-radius: 4px;
  }

  .signaturesPendents {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 20px;

    width: 100%;
    min-height: 91px;

    background: rgba(255, 180, 0, 0.1);
    border-radius: 4px;
  }

  .number {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 34px;
    line-height: 42px;
    display: flex;
    align-items: center;
    letter-spacing: 0.25px;
    color: #d62237;
  }

  .numberSignatures {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 34px;
    line-height: 42px;
    display: flex;
    align-items: center;
    letter-spacing: 0.25px;
    color: #ffb547;
  }

  .text {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    display: flex;
    align-items: center;
    letter-spacing: 0.1px;
    color: #424242;
  }
`;

export const ListagemPendencias = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  overflow-y: auto;
  width: 100%;
  height: 175px;

  padding: 20px;

  background: #f5f5f5;
  border-radius: 6px;

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: 0.15px;
  color: #000000;

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    letter-spacing: 0.15px;
    color: #000000;
  }

  .subtitle {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0.15px;
    color: #000000;
  }
`;

export const CardUserToShowDocuments = styled(Button)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0px;
  width: 100%;
  border-top: 1px solid #e0e0e0;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;
  color: #000000;
  padding: 8px;
  text-transform: capitalize;

  .name {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
  }

  .createdAt {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    display: flex;
    align-items: center;
    letter-spacing: 0.1px;
    color: #616161;
  }
`;

export const CardUser = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0px;
  width: 100%;
  border-top: 1px solid #e0e0e0;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;
  color: #000000;
  padding: 8px;
  text-transform: capitalize;

  .name {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
  }

  .createdAt {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    display: flex;
    align-items: center;
    letter-spacing: 0.1px;
    color: #616161;
  }
`;

export const SectionFilters = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 20px;

  width: 100%;
  height: 48px;
`;

export const TabSignatures = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  border-radius: 4px;
  background: #ffffff;
`;

export interface TabButtonProps {
  active: boolean;
}

export const TabButton = styled(Btn)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 48px;
  padding: 17px 43px;
  gap: 15px;
  width: 144px;

  background: #ffffff;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  color: rgba(0, 0, 0, 0.54);

  ${(props: TabButtonProps) =>
    props.active &&
    css`
      font-weight: 800;
      border-bottom: 2px solid #206da7;
      color: #206da7;
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    `}
`;

export const ButtonSelect = styled(Box)``;

export const SearchFilter = styled(Box)`
  width: 100%;
  height: 48px;
`;

export const SectionDocuments = styled(Box)`
  margin-top: 20px;
  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    /* identical to box height, or 175% */

    display: flex;
    align-items: center;
    letter-spacing: 0.15px;

    color: #000000;

    margin-bottom: 10px;
  }
`;

export const CardDocument = styled(Box)`
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 15px;
  gap: 10px;
  cursor: pointer;

  width: 100%;
  height: 84px;
  background: #ffffff;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 6px;

  .archive {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
  }

  :hover {
    background: #eeeeee;
  }
`;

export const Title = styled(Typography)``;

export const TextLoading = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.1px;
  color: #9e9e9e;
`;
